const isLoggedIn = localStorage.getItem('isLoggedIn')
const userRole = localStorage.getItem('userRole')

export const login = (state = { userRole: userRole, isLoggedIn: isLoggedIn}, action) => {
  switch (action.type) {
    case "LOGIN_WITH_EMAIL": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_FB": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_TWITTER": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_GOOGLE": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_GITHUB": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_JWT": {
      return {
        ...state,
        userRole: userRole,
        isLoggedIn: true,
        values: action.payload }
    }
    case "ADMIN_LOGIN_WITH_JWT": {
      return {
        ...state,
        userRole: "admin",
        isLoggedIn: true,
        values: action.payload }
    }
    case "ADMIN_LOGIN_WITH_LDAP": {
      return { 
        ...state,
        userRole: "admin",
        isLoggedIn: true,
        values: action.payload }
    }
    case "ADMIN_LOGIN_FROM_USER": {
      return {
        ...state,
        userRole: "admin",
        isLoggedIn: true,
        values: action.payload }
    }
    case "LOGOUT_WITH_JWT": {
      return {
        ...state,
        isLoggedIn: false,
        values: action.payload }
    }
    case "LOGOUT_WITH_FIREBASE": {
      return { ...state, values: action.payload }
    }
    case "CHANGE_ROLE": {
      return { ...state, userRole: action.userRole }
    }
    default: {
      return state
    }
  }
}
